import { gsap, ScrollTrigger } from "../utilities/gsap";

export default function StepperJS() {
    let stepper     = document.querySelector( ".carousel-stepper" ),
        image       = null,
        items       = null,
        item        = null,
        bullets     = null,
        bullet      = null,
        selected    = 0,
        isPaused    = true,
        tick        = null,
        duration    = 1,
        step,
        progress    = 0,
        progressSelector = null;
    
    // start the stepper with selected step
    function startStepper( selected ) {
        stepperBullets( selected );
        stepperItems( selected );
        stepperImage( selected );

        step = null;
        progress = 0;
        duration = stepper.dataset?.interval ?? duration;
        tick     = setInterval(() => {
            runningStepper( selected ) 
        }, 10);
    }
    
    // running the stepper with interval timeout
    function runningStepper() {
        if ( !isPaused ) {
            progressSelector = "--vl-stepper";
            step = (duration * 1000) / 10;
            progress += 100 / step;

            gsap.set( bullet, {
                ease                : "none",
                [progressSelector]  : `${ progress }%`
            } )

            // if the progress hit 100% then we need to reset the stepper and goes to the next step order
            if ( progress >= 100 ) {
                resetStepper()

                selected = selected < bullets.length - 1 ? selected + 1 : selected = 0;

                startStepper( selected )
            }
        }
    }

    // reset the stepper with clearing out the interval
    function resetStepper( selector = null ) {
        gsap.set( selector ? selector : bullet, {
            ease                : "none",
            [progressSelector]  : "0%"
        } )

        if ( tick ) clearTimeout( tick )
    }

    // active style for the bullets
    function stepperBullets( index = selected ) {
        bullets = stepper.querySelectorAll( ".carousel-stepper-bullet" );
        bullet  = bullets[ index ];

        // remove all active state
        bullets.forEach( el => el.classList.remove( "active" ) );

        // add active state
        bullet.classList.add("active")
    }

    // active style for stepper content item
    function stepperItems( index = selected ) {
        items   = stepper.querySelectorAll( ".carousel-stepper-item" ),
        item    = items[ index ];

        // remove all active state
        items.forEach( el => el.classList.remove( "active" ) );

        // add active state
        item.classList.add("active")
    }

    // image will changes depends on the selected order
    function stepperImage( index = selected ) {
        image = stepper.querySelector( ".carousel-stepper-image" )
        
        gsap.to( image, {
            yPercent : `${( index ? -1 : 0 ) * ( index * 100 ) }`,
        } )
    }
   
    function stepperListener() {
        // listen the item event
        if ( items ) {
            items.forEach((el, index) => {
                el.addEventListener( "click", () => {
                    selected = index
                    resetStepper( this )
                    handleClick( index )
                } )

                el.addEventListener( "mouseenter", () => {
                    handleHover( index, true )
                } )

                el.addEventListener( "mouseleave", () => {
                    handleHover( index, false )
                } )
            });
        }

        // listen the progress bullet event
        if ( bullets ) {
            bullets.forEach((el, index) => {
                el.addEventListener( "click", () => {
                    selected = index
                    resetStepper( this )
                    handleClick( index )
                } )

                el.addEventListener( "mouseenter", () => {
                    handleHover( index, true )
                } )

                el.addEventListener( "mouseleave", () => {
                    handleHover( index, false )
                } )
            })
        }
    }

    // change the isPaused state when hovering the stepper content item
    function handleHover( index = selected, state = true ) {
        if ( index != selected ) return;

        isPaused = state

        return true
    }

    // change the stepper selected value when the stepper content item clicked
    function handleClick( index ) { 
        startStepper( index )
    }

    function init() {
        startStepper( selected )
        stepperListener()

        ScrollTrigger.create( {
            trigger: stepper,
            start: "top 50%",
            onEnter: () => {
                isPaused = false;
            },
            onLeave: () => {
                isPaused = true
            },
            onEnterBack: () => {
                isPaused = false;
            },
            onLeaveBack: () => {
                isPaused = true
            }
        } )
    }

    if ( stepper ) init()
}